import React, { Component } from 'react';

import {
  getprogcals,
  clearErrors,
  deleteProgCal,
  postCalibracion,
  editProgCal
} from '../../../redux/actions/dataactions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FaArrowLeft, FaCheck, FaCheckCircle, FaPlus, FaTrash } from 'react-icons/fa';

import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';

const isValidProgCalRow = (r) =>
  r && typeof r === 'object' && (r.progid || r.id || r._id);

export class ListaCalProg extends Component {
  constructor() {
    super();
    this.state = {
      horainicio: '',
      horafinal: '',
      fecha: '',
      numcertificado: '',
      errors: {},
      open: false,
      opendelete: false,
      progid: '',
      selectedFile: null,
      aprobado: {}
    };
  }

  componentDidMount() {
    this.props.getprogcals(this.props.equipoId);
  }

  componentWillUnmount() {
    // Asegúrate de que clearErrors limpie también UI.aprobado en el reducer
    this.props.clearErrors();
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};

    if (props.UI?.errors && props.UI.errors !== state.errors) {
      newState.errors = props.UI.errors;
    }
    if (props.UI?.aprobado && props.UI.aprobado !== state.aprobado) {
      newState.aprobado = props.UI.aprobado;
    }

    return Object.keys(newState).length > 0 ? newState : null;
  }

  handleOpen = (rawdataprogid, rawdatafecha, rawdatahora) => {
    this.setState({
      open: true,
      progid: rawdataprogid || '',
      fecha: rawdatafecha || '',
      horainicio: rawdatahora || '',
      horafinal: '',
      numcertificado: '',
      aprobado: {},
      errors: {}
    });
    this.props.clearErrors();
  };

  // Cierra sin efectos secundarios
  handleClose = () => {
    this.setState({
      open: false,
      errors: {},
      aprobado: {}
    });
    this.props.clearErrors();
  };

  // Cuando hubo aprobado, marca 'Realizado' y luego cierra
  handleContinue = () => {
    const { progid } = this.state;
    if (progid) {
      this.props.editProgCal({ nuevoestado: 'Realizado' }, progid, this.props.equipoId);
    }
    this.handleClose();
  };

  handleOpenDelete = (rawdataprogid) => {
    this.setState({ opendelete: true, progid: rawdataprogid || '', aprobado: {}, errors: {} });
    this.props.clearErrors();
  };

  handleCloseDelete = () => {
    this.setState({ opendelete: false, errors: {}, aprobado: {} });
    this.props.clearErrors();
  };

  handleDelete = () => {
  

    this.props.deleteProgCal(this.state.progid, this.props.equipoId);
  };

  handlePostCal = () => {
    const { credentials } = this.props.user;
    const newCalibracion = {
      fecha: this.state.fecha,
      horainicio: this.state.horainicio,
      horafinal: this.state.horafinal,
      numcertificado: this.state.numcertificado,
      programacionid:this.state.progid
    };

   
    this.props.postCalibracion(newCalibracion, this.props.clienteId, this.props.equipoId);
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { progracals, loadingcal } = this.props.data;
    const { errors } = this.state;
    const { UI: { loading } } = this.props;

    const isAprobado = !!(this.state.aprobado && this.state.aprobado.mensaje);

    // Filtra objetos de feedback (p. ej., { message: "..." }) y mapea id
    const raw = Array.isArray(progracals) ? progracals : [];
    const rows = raw
      .filter(isValidProgCalRow)
      .map((row) => ({
        id: row.progid || row.id || row._id,
        ...row
      }));

    const columns = [
      {
        field: 'actions',
        headerName: 'Acciones',
        width: 150,
        sortable: false,
        renderCell: (params) => (
          <Box>
            <Tooltip title="Realizar Calibración">
              <span>
                <IconButton
                  size="small"
                  onClick={() => this.handleOpen(params.row.progid, params.row.fecha, params.row.hora)}
                  disabled={params.row.estado === 'Realizado'}
                >
                    <FaPlus size={16} color={params.row.estado === 'Realizado' ? '#BDBDBD' : '#03178C'} />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="Borrar Programación">
              <IconButton size="small" onClick={() => this.handleOpenDelete(params.row.progid)}>
                <FaTrash size={16} />
              </IconButton>
            </Tooltip>
          </Box>
        )
      },
      { field: 'fecha', headerName: 'Fecha', width: 120 },
      { field: 'mesnombre', headerName: 'Mes', width: 120 },
      { field: 'hora', headerName: 'Hora', width: 120 },
      { field: 'duracion', headerName: 'Duración', width: 120 },
      { field: 'estado', headerName: 'Estado', width: 120 },
      { field: 'lugar', headerName: 'Lugar', width: 120 }
    ];

    const CustomToolbar = () => (
      <Box p={1}>
        <GridToolbarQuickFilter placeholder="Buscar..." />
      </Box>
    );

    const tabla = !loadingcal ? (
      <Box sx={{ width: '100%' }}>
        <Typography sx={{ fontSize: '16px', color: '#03178c', fontWeight: 600 }}>
          Calibraciones Programadas
        </Typography>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row.progid || row.id || row._id}
          pageSize={5}
          rowsPerPageOptions={[5, 10, 25]}
          disableSelectionOnClick
          components={{ Toolbar: CustomToolbar }}
          sx={{
            height: 500,
            width: '100%',
            mt: 2,
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: 'primary.main',
              color: 'white'
            }
          }}
        />
      </Box>
    ) : (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress size={50} color="primary" />
      </Box>
    );

    return (
      <div className="listamtoprog-container">
        <div className="listamtoprog-table">{tabla}</div>

        {/* Dialog Realizar Calibración */}
        <Dialog open={this.state.open} onClose={this.handleClose} fullWidth maxWidth="sm">
          {isAprobado ? (
            <Box className="div-aprobado">
              <Box className="div-icono-aprobado">
                <FaCheck color="#ffffff" className="icono-aprobado" />
              </Box>
              <Typography className="text-aprobado">Reporte Cargado Exitosamente</Typography>
            </Box>
          ) : (
            <>
              <DialogTitle>
                <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}>
                  Realizar Calibración
                </Typography>
              </DialogTitle>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} mt={2}>
                    <TextField
                      required
                      type="date"
                      name="fecha"
                      id="fecha"
                      label="Fecha de Realización"
                      value={this.state.fecha}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      helperText={errors.fecha}
                      error={!!errors.fecha}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      type="time"
                      name="horainicio"
                      id="horainicio"
                      label="Hora de Inicio"
                      value={this.state.horainicio}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      helperText={errors.horainicio}
                      error={!!errors.horainicio}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      type="time"
                      name="horafinal"
                      id="horafinal"
                      label="Hora Final"
                      value={this.state.horafinal}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      helperText={errors.horafinal}
                      error={!!errors.horafinal}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      required
                      type="text"
                      name="numcertificado"
                      id="numcertificado"
                      label="Número del Certificado"
                      value={this.state.numcertificado}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      helperText={errors.numcertificado}
                      error={!!errors.numcertificado}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
            </>
          )}

          <DialogActions sx={{ justifyContent: 'flex-end' }}>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleClose}>
                <FaArrowLeft />
              </IconButton>
            </Tooltip>

            {loading ? (
              <CircularProgress size={30} color="primary" />
            ) : isAprobado ? (
              <Tooltip title="Continuar">
                <IconButton onClick={this.handleContinue}>
                  <FaCheckCircle color='#03178C'/>
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Realizar Calibración">
                <IconButton onClick={this.handlePostCal}>
                  <FaPlus color='#03178C' />
                </IconButton>
              </Tooltip>
            )}
          </DialogActions>
        </Dialog>

        {/* Dialog Borrar Programación */}
        <Dialog open={this.state.opendelete} onClose={this.handleCloseDelete} fullWidth maxWidth="sm">
          {isAprobado ? (
            <Box className="div-aprobado">
              <Box className="div-icono-delete">
                <FaTrash color="#ffffff" className="icono-aprobado" />
              </Box>
              <Typography className="text-aprobado">Programación Borrada Exitosamente</Typography>
            </Box>
          ) : (
            <DialogTitle>
              <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}>
                ¿Estás seguro de borrar programación de Calibración?
              </Typography>
            </DialogTitle>
          )}

          <DialogActions sx={{ justifyContent: 'flex-end' }}>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleCloseDelete}>
                <FaArrowLeft />
              </IconButton>
            </Tooltip>

            {loading ? (
              <CircularProgress size={30} color="primary" />
            ) : isAprobado ? (
              <Tooltip title="Continuar">
                <IconButton onClick={this.handleCloseDelete}>
                  <FaCheckCircle color="#f9044e" />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Borrar Programación">
                <IconButton onClick={this.handleDelete}>
                  <FaTrash color="#f9044e" />
                </IconButton>
              </Tooltip>
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

ListaCalProg.propTypes = {
  getprogcals: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  deleteProgCal: PropTypes.func.isRequired,
  editProgCal: PropTypes.func.isRequired,
  postCalibracion: PropTypes.func.isRequired,
  equipoId: PropTypes.string,
  clienteId: PropTypes.string
};

const mapActionsToProps = { getprogcals, clearErrors, deleteProgCal, editProgCal, postCalibracion };

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
  UI: state.UI
});

export default connect(mapStateToProps, mapActionsToProps)(ListaCalProg);
